// formulář objednávky
function orderFormCz() {
  const locale = $('#locale').val();
  let priceLabelHolder = $('.price-label-holder');
  let nameLabelHolder = $('.name-label-holder');
  let yearOfPurchaseLabelHolder = $('.year-of-purchase-label-holder');
  let yearOfPurchaseLabel = $('.year-of-purchase-label');
  $('#insurance_subject_order_type_0').click(function () {
    $('.bike-drivers').removeClass('is-hidden');
    $('.e-bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    if (locale === 'sk') {
      $('.form-name-text').attr('placeholder', 'napr. MATÚŠ BICYKEL');
      $('.form-price-text').attr('placeholder', 'napr. 1520');
    } else {
      $('.form-name-text').attr('placeholder', 'např. HONZA KOLO');
      $('.form-price-text').attr('placeholder', 'např. 30 990');
    }
    $('.update-side-js').addClass('is-hidden');
    $('#order-side-step-bike').removeClass('is-hidden');
    displayOrderFormBlocks(
      priceLabelHolder.data('headline-bike'),
      priceLabelHolder.data('hint-bike'),
      nameLabelHolder.data('headline-bike'),
      nameLabelHolder.data('hint-bike')
    );
    changeLabel(
      yearOfPurchaseLabel,
      yearOfPurchaseLabelHolder.data('year-of-purchase-headline-bike'),
      yearOfPurchaseLabelHolder.data('year-of-purchase-hint-bike')
    );
  });

  $('#insurance_subject_order_type_1').click(function () {
    $('.e-bike-drivers').removeClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    if (locale === 'sk') {
      $('.form-name-text').attr('placeholder', 'napr. DÁVID EBIKE');
      $('.form-price-text').attr('placeholder', 'napr. 2150');
    } else {
      $('.form-name-text').attr('placeholder', 'např. JANA ELEKTROKOLO');
      $('.form-price-text').attr('placeholder', 'např. 50 990');
    }
    $('.update-side-js').addClass('is-hidden');
    $('#order-side-step-ebike').removeClass('is-hidden');
    displayOrderFormBlocks(
      priceLabelHolder.data('headline-ebike'),
      priceLabelHolder.data('hint-ebike'),
      nameLabelHolder.data('headline-ebike'),
      nameLabelHolder.data('hint-ebike')
    );
    changeLabel(
      yearOfPurchaseLabel,
      yearOfPurchaseLabelHolder.data('year-of-purchase-headline-ebike'),
      yearOfPurchaseLabelHolder.data('year-of-purchase-hint-ebike')
    );
  });

  $('#insurance_subject_order_type_2').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').removeClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    if (locale === 'sk') {
      $('.form-name-text').attr('placeholder', 'napr. FILIP KOLOBEŽKA');
      $('.form-price-text').attr('placeholder', 'napr. 810');
    } else {
      $('.form-name-text').attr('placeholder', 'např. MATY KOLOBĚŽKA');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
    }
    $('.update-side-js').addClass('is-hidden');
    $('#order-side-step-scooter').removeClass('is-hidden');
    displayOrderFormBlocks(
      priceLabelHolder.data('headline-scooter'),
      priceLabelHolder.data('hint-scooter'),
      nameLabelHolder.data('headline-scooter'),
      nameLabelHolder.data('hint-scooter')
    );
    changeLabel(
      yearOfPurchaseLabel,
      yearOfPurchaseLabelHolder.data('year-of-purchase-headline-scooter'),
      yearOfPurchaseLabelHolder.data('year-of-purchase-hint-scooter')
    );
  });

  $('#insurance_subject_order_type_3').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').removeClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    if (locale === 'sk') {
      $('.form-name-text').attr('placeholder', 'napr. NATÁLIA KOLOBEŽKA');
      $('.form-price-text').attr('placeholder', 'napr. 810');
    } else {
      $('.form-name-text').attr('placeholder', 'např. PATRIK E-KOLOBĚŽKA');
      $('.form-price-text').attr('placeholder', 'např. 24 990');
    }
    $('.update-side-js').addClass('is-hidden');
    $('#order-side-step-escooter').removeClass('is-hidden');
    displayOrderFormBlocks(
      priceLabelHolder.data('headline-escooter'),
      priceLabelHolder.data('hint-escooter'),
      nameLabelHolder.data('headline-escooter'),
      nameLabelHolder.data('hint-escooter')
    );
    changeLabel(
      yearOfPurchaseLabel,
      yearOfPurchaseLabelHolder.data('year-of-purchase-headline-escooter'),
      yearOfPurchaseLabelHolder.data('year-of-purchase-hint-escooter')
    );
  });

  $('#insurance_subject_order_type_4').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').removeClass('is-hidden');
    if (locale === 'sk') {
      $('.form-name-text').attr('placeholder', 'napr. EMA CYKLOVOZÍK');
      $('.form-price-text').attr('placeholder', 'napr. 950');
    } else {
      $('.form-name-text').attr('placeholder', 'např. TOBIK CYKLOVOZÍK');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
    }
    $('.update-side-js').addClass('is-hidden');
    $('#order-side-step-trailer').removeClass('is-hidden');
    displayOrderFormBlocks(
      priceLabelHolder.data('headline-trailer'),
      priceLabelHolder.data('hint-trailer'),
      nameLabelHolder.data('headline-trailer'),
      nameLabelHolder.data('hint-trailer')
    );
    changeLabel(
      yearOfPurchaseLabel,
      yearOfPurchaseLabelHolder.data('year-of-purchase-headline-trailer'),
      yearOfPurchaseLabelHolder.data('year-of-purchase-hint-trailer')
    );
  });

  function matchStart(params, data) {
    params.term = params.term || '';
    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
      return data;
    }
    return false;
  }

  $('.select2').select2({
    matcher: function (params, data) {
      return matchStart(params, data);
    },
  });

  $(document).ready(function () {
    let checkbox = $('.forced-required');
    if (checkbox.length) {
      checkbox.prop('checked', true);
      if (checkbox.length) {
        checkbox.on('click', function () {
          checkbox.prop('checked', true);
        });
      }
    }

    // if ($('.order-2').length) {
    //   // scroll na sekci coinsurance
    //   $('html, body').animate(
    //     {
    //       scrollTop: $('#subject-coinsurances').offset().top,
    //     },
    //     800,
    //     function () {}
    //   );
    // }

    // zajištění načtených hodnot a schování/zobrazení správných polí
    let chosenSubjectType = $(
      "input[name='insurance_subject_order[type]']:checked"
    ).val();
    chosenSubjectType = parseInt(chosenSubjectType);
    if (chosenSubjectType == 1) {
      $('.bike-drivers').removeClass('is-hidden');
      $('.e-bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      if (locale === 'sk') {
        $('.form-name-text').attr('placeholder', 'napr. MATÚŠ BICYKEL');
        $('.form-price-text').attr('placeholder', 'napr. 1520');
      } else {
        $('.form-name-text').attr('placeholder', 'např. HONZA KOLO');
        $('.form-price-text').attr('placeholder', 'např. 30 990');
      }
      displayOrderFormBlocks(
        priceLabelHolder.data('headline-bike'),
        priceLabelHolder.data('hint-bike'),
        nameLabelHolder.data('headline-bike'),
        nameLabelHolder.data('hint-bike')
      );
      changeLabel(
        yearOfPurchaseLabel,
        yearOfPurchaseLabelHolder.data('year-of-purchase-headline-bike'),
        yearOfPurchaseLabelHolder.data('year-of-purchase-hint-bike')
      );
    }
    if (chosenSubjectType == 2) {
      $('.e-bike-drivers').removeClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      if (locale === 'sk') {
        $('.form-name-text').attr('placeholder', 'napr. DÁVID EBIKE');
        $('.form-price-text').attr('placeholder', 'napr. 2150');
      } else {
        $('.form-name-text').attr('placeholder', 'např. JANA ELEKTROKOLO');
        $('.form-price-text').attr('placeholder', 'např. 50 990');
      }
      displayOrderFormBlocks(
        priceLabelHolder.data('headline-ebike'),
        priceLabelHolder.data('hint-ebike'),
        nameLabelHolder.data('headline-ebike'),
        nameLabelHolder.data('hint-ebike')
      );
      changeLabel(
        yearOfPurchaseLabel,
        yearOfPurchaseLabelHolder.data('year-of-purchase-headline-ebike'),
        yearOfPurchaseLabelHolder.data('year-of-purchase-hint-ebike')
      );
    }
    if (chosenSubjectType == 3) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').removeClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      if (locale === 'sk') {
        $('.form-name-text').attr('placeholder', 'napr. FILIP KOLOBEŽKA');
        $('.form-price-text').attr('placeholder', 'napr. 810');
      } else {
        $('.form-name-text').attr('placeholder', 'např. MATY KOLOBĚŽKA');
        $('.form-price-text').attr('placeholder', 'např. 15 490');
      }
      displayOrderFormBlocks(
        priceLabelHolder.data('headline-scooter'),
        priceLabelHolder.data('hint-scooter'),
        nameLabelHolder.data('headline-scooter'),
        nameLabelHolder.data('hint-scooter')
      );
      changeLabel(
        yearOfPurchaseLabel,
        yearOfPurchaseLabelHolder.data('year-of-purchase-headline-scooter'),
        yearOfPurchaseLabelHolder.data('year-of-purchase-hint-scooter')
      );
    }
    if (chosenSubjectType == 4) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').removeClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      if (locale === 'sk') {
        $('.form-name-text').attr('placeholder', 'napr. NATÁLIA KOLOBEŽKA');
        $('.form-price-text').attr('placeholder', 'napr. 810');
      } else {
        $('.form-name-text').attr('placeholder', 'např. PATRIK E-KOLOBĚŽKA');
        $('.form-price-text').attr('placeholder', 'např. 24 990');
      }
      displayOrderFormBlocks(
        priceLabelHolder.data('headline-escooter'),
        priceLabelHolder.data('hint-escooter'),
        nameLabelHolder.data('headline-escooter'),
        nameLabelHolder.data('hint-escooter')
      );
      changeLabel(
        yearOfPurchaseLabel,
        yearOfPurchaseLabelHolder.data('year-of-purchase-headline-escooter'),
        yearOfPurchaseLabelHolder.data('year-of-purchase-hint-escooter')
      );
    }
    if (chosenSubjectType == 5) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').removeClass('is-hidden');
      if (locale === 'sk') {
        $('.form-name-text').attr('placeholder', 'napr. EMA CYKLOVOZÍK');
        $('.form-price-text').attr('placeholder', 'napr. 950');
      } else {
        $('.form-name-text').attr('placeholder', 'např. TOBIK CYKLOVOZÍK');
        $('.form-price-text').attr('placeholder', 'např. 15 490');
      }
      displayOrderFormBlocks(
        priceLabelHolder.data('headline-trailer'),
        priceLabelHolder.data('hint-trailer'),
        nameLabelHolder.data('headline-trailer'),
        nameLabelHolder.data('hint-trailer')
      );
      changeLabel(
        yearOfPurchaseLabel,
        yearOfPurchaseLabelHolder.data('year-of-purchase-headline-trailer'),
        yearOfPurchaseLabelHolder.data('year-of-purchase-hint-trailer')
      );
    }

    /*    $("input[type='text']").change(function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });*/

    let customSelect = $('.custom-select');
    customSelect.on('click', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectBike = $('#insurance_subject_order_manufacturerBike');
    selectBike.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectEBike = $('#insurance_subject_order_manufacturerEBike');
    selectEBike.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectScooter = $('#insurance_subject_order_manufacturerScooter');
    selectScooter.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectEScooter = $('#insurance_subject_order_manufacturerEScooter');
    selectEScooter.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectTrailer = $('#insurance_subject_order_manufacturerTrailer');
    selectTrailer.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#subject-added-insurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    // step 1+2 update
    const subjectOrderFullName = $('#insurance_subject_order_fullName');
    const subjectOrderZip = $('#insurance_subject_order_zipCode');
    const subjectOrderEmail = $('#insurance_subject_order_email');
    const subjectOrderPhone = $('#insurance_subject_order_phoneNumber');
    if (subjectOrderFullName.length && locale === 'sk') {
      subjectOrderFullName.attr('placeholder', 'napr. JÁN BEDNÁRIK');
      subjectOrderZip.attr('placeholder', 'napr. 81103');
      subjectOrderEmail.attr('placeholder', 'vasemail@azet.sk');
      subjectOrderPhone.attr('placeholder', 'napr. 905 405 405');
    }
  });
}

function changeLabel(label, newText, newHintText) {
  label
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith(newText);
  label.find('.wowtooltip-dropdown__content').text(newHintText);
}

function displayOrderFormBlocks(
  priceLabelHeadline,
  priceLabelHint,
  nameLabelHeadline,
  nameLabelHint
) {
  let priceLabelHolder = $('.price-label-holder');
  priceLabelHolder.html(
    '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">' +
      priceLabelHeadline +
      '\n' +
      '                      <wow-tooltip class="wowtooltip">\n' +
      '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
      '                        <span class="icon icon--icon-info-blank">\n' +
      '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
      '                        </span>\n' +
      '                        </div>\n' +
      '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
      '                          <div role="tooltip" class="wowtooltip-dropdown__content">' +
      priceLabelHint +
      '</div>\n' +
      '                        </div>\n' +
      '                      </wow-tooltip>\n' +
      '                    </label>'
  );

  let nameLabelHolder = $('.name-label-holder');
  nameLabelHolder.html(
    '<label for="insurance_subject_order_name" class="label-help required">' +
      nameLabelHeadline +
      '\n' +
      '                      <wow-tooltip class="wowtooltip">\n' +
      '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
      '                        <span class="icon icon--icon-info-blank">\n' +
      '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
      '                        </span>\n' +
      '                        </div>\n' +
      '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
      '                          <div role="tooltip" class="wowtooltip-dropdown__content">' +
      nameLabelHint +
      '</div>\n' +
      '                        </div>\n' +
      '                      </wow-tooltip>\n' +
      '                    </label>'
  );
}
